/**
 * 智能设备页统一深链：固定 query farmId / landId / deviceId / tab / deviceType / channelNo。
 * tab: detail | preview | ptz | schedule
 * schedule 仅打开智能设备页设备级 HikvisionScheduleEditor，不是田间影像租户抓拍面板。
 * deviceType=CAMERA 时列表「设备类型」筛到摄像头。
 */

export const SMART_DEVICE_TABS = Object.freeze({
  DETAIL: 'detail',
  PREVIEW: 'preview',
  PTZ: 'ptz',
  SCHEDULE: 'schedule',
});

/**
 * @param {{ farmId?: string|null, landId?: string|null, deviceId?: string|null, tab?: string|null, deviceType?: string|null, channelNo?: string|number|null }} opts
 * @returns {string} 带 query 的路径
 */
export function buildSmartDeviceUrl({ farmId, landId, deviceId, tab, deviceType, channelNo } = {}) {
  const q = new URLSearchParams();
  if (farmId != null && String(farmId).trim()) q.set('farmId', String(farmId).trim());
  if (landId != null && String(landId).trim()) q.set('landId', String(landId).trim());
  if (deviceId != null && String(deviceId).trim()) q.set('deviceId', String(deviceId).trim());
  if (tab != null && String(tab).trim()) q.set('tab', String(tab).trim());
  if (deviceType != null && String(deviceType).trim()) q.set('deviceType', String(deviceType).trim());
  if (channelNo != null && String(channelNo).trim()) q.set('channelNo', String(channelNo).trim());
  const qs = q.toString();
  return qs ? `/production/land/smart-device?${qs}` : '/production/land/smart-device';
}

/**
 * 按设备类型推断 tab：摄像头走预览，其它进详情。
 * @param {{ deviceType?: string, name?: string }|null} device
 * @param {string} [preferredTab]
 */
export function resolveSmartDeviceTab(device, preferredTab) {
  if (preferredTab) return preferredTab;
  const type = String(device?.deviceType || device?.deviceRole || '').toUpperCase();
  const name = String(device?.deviceName || device?.name || '');
  if (
    type === 'CAMERA' ||
    type === 'IP_CAMERA' ||
    type === 'FARM_CAMERA' ||
    /摄像头|摄像机|监控|海康/.test(name)
  ) {
    return SMART_DEVICE_TABS.PREVIEW;
  }
  return SMART_DEVICE_TABS.DETAIL;
}
